import NewsIcon from './NewsIcon.svelte';
import type { AgPromise, ICellRendererComp, ICellRendererParams } from '@ag-grid-community/core';
import { signal } from '@preact/signals-react';
import { mount, unmount } from 'svelte';

function toChangeDirection(changeClose: unknown): number {
    if (typeof changeClose !== 'number') return 0;
    return changeClose > 0 ? 1 : changeClose < 0 ? -1 : 0;
}

export const makeNewsIconCellRenderer = ({
    symbolFieldId,
    changeCloseFieldId,
}: {
    symbolFieldId: string;
    changeCloseFieldId: string;
}): { new (): ICellRendererComp } => {
    return class CellRenderer implements ICellRendererComp {
        div: HTMLDivElement = document.createElement('div');
        root: ReturnType<typeof mount> | undefined;

        ticker = signal<string | undefined>(undefined);
        changeDirection = signal<number>(0);

        getGui(): HTMLElement {
            this.div.className = 'w-full flex justify-center';
            return this.div;
        }

        init(params: ICellRendererParams<any, any>): void | AgPromise<void> {
            this.ticker.value = symbolFieldId ? (params.data?.[symbolFieldId] ?? undefined) : undefined;
            this.changeDirection.value = changeCloseFieldId ? toChangeDirection(params.data?.[changeCloseFieldId]) : 0;

            this.root = mount(NewsIcon, {
                target: this.div,
                props: { ticker: this.ticker, changeDirection: this.changeDirection },
            });
        }

        refresh(params: ICellRendererParams<any, any>): boolean {
            this.ticker.value = symbolFieldId ? (params.data?.[symbolFieldId] ?? undefined) : undefined;
            this.changeDirection.value = changeCloseFieldId ? toChangeDirection(params.data?.[changeCloseFieldId]) : 0;

            return true;
        }

        destroy(): void {
            if (this.root) {
                unmount(this.root);
            }
        }
    };
};
